module.exports = __webpack_public_path__ + "img/pinterest.5baca202.svg";